import { render } from "./HeroSectionSliderList.vue?vue&type=template&id=806dae16&scoped=true"
import script from "../js/hero-section-slider-list.js?vue&type=script&lang=js"
export * from "../js/hero-section-slider-list.js?vue&type=script&lang=js"

import "./HeroSectionSliderList.vue?vue&type=style&index=0&id=806dae16&scoped=true&lang=css"

import exportComponent from "/Users/mdmahamudurzamanbhuyan/Sites/localhost/disposhop_jars/dispo_admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-806dae16"]])

export default __exports__